import './RankingDetailsView.css';
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import config from '@config';
import Announcement from '@views/Announcement';
import RankingHeader from '@views/RankingHeader';
import RankingParticipants from '@views/RankingParticipants';
import Error from '@views/Error';

export const RankingDetailsView = ({ notFound, isCurrentDataReady }) => (
  <div className="RankingDetailsView">
    <Announcement />
    <div className="hero-bg">
      <div className="hero-content">
        <h2>Mis torneos</h2>
        <p>Creá torneos para jugar con tus amigos</p>
      </div>
    </div>
    <div className="RankingDetails-container">
      {notFound ? (
        <div className="card">
          <Helmet>
            <title>El Ranking no existe</title>
          </Helmet>

          <Error message="El ranking no existe." />
        </div>
      ) : !isCurrentDataReady ? (
        <div className="card ranking-details-loading-card">
          <div className="ranking-details-loading-spinner" />
        </div>
      ) : (
        <div className="card">
          <RankingHeader />
          <RankingParticipants />
        </div>
      )}
    </div>
  </div>
);

RankingDetailsView.propTypes = {
  notFound: PropTypes.bool,
  isCurrentDataReady: PropTypes.bool,
};

RankingDetailsView.defaultProps = {
  notFound: false,
  isCurrentDataReady: false,
};

export default RankingDetailsView;
